// src/toolkitServices/bankApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const bankApi = createApi({
  reducerPath: "bankApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Bank"],
  endpoints: (builder) => ({
    // ➕ Create Bank
    addBank: builder.mutation({
      query: (newBank) => ({
        url: "/banks/create",
        method: "POST",
        body: newBank,
      }),
      invalidatesTags: ["Bank"],
    }),

    // 📋 Get All Banks
    // (same params style as department: page, limit, search, company, active)
    getAllBanks: builder.query({
      query: ({ page = 1, limit = 10, search = "", company, active } = {}) => {
        const params = { page, limit, q: search };
        if (company) params.company = company;
        if (typeof active === "boolean") params.active = active;
        return { url: "/banks", params };
      },
      providesTags: ["Bank"],
    }),

    // 🆔 Get Bank by ID
    getBankById: builder.query({
      query: (id) => `/banks/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Bank", id }],
    }),

    // ✏️ Update Bank
    updateBank: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/banks/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Bank"],
    }),

    // 🗑️ Delete Bank
    deleteBank: builder.mutation({
      query: (id) => ({
        url: `/banks/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Bank"],
    }),

    // 🟢 Activate Bank
    activateBank: builder.mutation({
      query: (id) => ({
        url: `/banks/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Bank"],
    }),

    // 🔴 Deactivate Bank
    deactivateBank: builder.mutation({
      query: (id) => ({
        url: `/banks/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Bank"],
    }),
  }),
});

export const {
  useAddBankMutation,
  useGetAllBanksQuery,
  useGetBankByIdQuery,
  useUpdateBankMutation,
  useDeleteBankMutation,
  useActivateBankMutation,
  useDeactivateBankMutation,
} = bankApi;

export default bankApi;
